module.exports = __webpack_public_path__ + "static/media/2.62636e47.jpg";